import { InherentRiskCategoryEnum } from '@/gen/inventory/v1/company_service_pb'

import { SET_IRQ_MODAL_LABEL } from '@/pages/company-drawer/company-overview/set-irq-modal/labels'
import { EvidenceQuotes } from '@/pages/company-drawer/company-overview/set-irq-modal/lema-suggestions-card/evidence-quotes'
import { PermissionsSummary } from '@/pages/company-drawer/company-overview/set-irq-modal/lema-suggestions-card/permissions-summary'
import type { SourceDisplay } from '@/pages/company-drawer/company-overview/set-irq-modal/lema-suggestions-card/types'

type SourceBodyProps = {
  source: SourceDisplay
  answer: string
  categoryEnum: InherentRiskCategoryEnum
  businessOwnerName?: string
}

export const SourceBody = ({
  source,
  answer,
  categoryEnum,
  businessOwnerName,
}: SourceBodyProps) => {
  if (source.isIntake) {
    return (
      <p className='text-main-foreground-primary text-body-small'>
        {SET_IRQ_MODAL_LABEL.INTAKE_BODY}
      </p>
    )
  }

  const isPermissionCategory =
    categoryEnum === InherentRiskCategoryEnum.DATA ||
    categoryEnum === InherentRiskCategoryEnum.ATTACK_SURFACE
  const permissionsNode =
    isPermissionCategory && source.permissions.length > 0 ? (
      <PermissionsSummary
        permissions={source.permissions}
        answer={answer}
        categoryEnum={categoryEnum}
      />
    ) : null

  if (source.evidenceQuotes && source.evidenceQuotes.length > 0) {
    return (
      <>
        <EvidenceQuotes quotes={source.evidenceQuotes} businessOwnerName={businessOwnerName} />
        {permissionsNode}
      </>
    )
  }
  if (source.evidence?.trim()) {
    return <p className='text-main-foreground-primary text-body-small'>{source.evidence}</p>
  }
  return permissionsNode
}
